// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kc5BgRH9zlYqk5DGkuVQ{width:532px;min-width:492px;max-width:100%}.kc5BgRH9zlYqk5DGkuVQ .hzEHrP8m7RE1xyQijkCq{padding:12px}.kc5BgRH9zlYqk5DGkuVQ .yvJftOWtyb4Qq1bE1HGp{margin:8px 0}.kc5BgRH9zlYqk5DGkuVQ .yvJftOWtyb4Qq1bE1HGp.AA4ROREMNm0Ec6UevxmT{margin-bottom:24px}.kc5BgRH9zlYqk5DGkuVQ .Aql5dXWOyjQXN0tI2eXx{padding-left:12px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `kc5BgRH9zlYqk5DGkuVQ`,
	"selectPadding": `hzEHrP8m7RE1xyQijkCq`,
	"noEmailCheckbox": `yvJftOWtyb4Qq1bE1HGp`,
	"additionSpace": `AA4ROREMNm0Ec6UevxmT`,
	"textInput": `Aql5dXWOyjQXN0tI2eXx`
};
export default ___CSS_LOADER_EXPORT___;
